import { AccountSettingsCard } from "../../../components/ops/AccountSettingsCard";
import { PageHeader } from "../../../components/ops/PageHeader";

export function AdminSettingsPage() {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Manage your admin profile" />
      <AccountSettingsCard />
    </div>
  );
}
